export const setExpiredSession = () => {
    // Solo forzar caducidad si había sesión activa explícita
    if (localStorage.getItem("logged") === "true") {
        localStorage.setItem("logged", "false");
        alert("Sesión caducada. Vuelva a introducir sus credenciales, por favor.")
        window.location.href = '/'
    }
}